// Grabb logo — uses the official orange smiley-G mark.
const Logo = ({ size = 36, withText = true }) => (
  <div className="flex items-center gap-2">
    <img
      src="https://customer-assets.emergentagent.com/job_vibe-sync-73/artifacts/ieil0xt0_ChatGPT%20Image%20Jun%2013%2C%202026%2C%2006_59_41%20PM.png"
      alt="Grabb"
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: "contain", display: "block", flexShrink: 0 }}
      data-testid="grabb-logo-mark"
    />
    {withText && (
      <span className="font-heading font-black text-2xl tracking-tighter" data-testid="grabb-logo-text">
        GRABB
      </span>
    )}
  </div>
);

export default Logo;
